(ns common.schema.entities.vault.zap-vault
  (:require [common.schema.entities.common :as common-schema]
            [common.schema.option-filters :as option-filters]
            [common.schema.schema-utils :as su]))

(def schema
  (concat
   common-schema/common-owner
   (su/text-unique-global :zap-vault/unique-id "ID" {})
   (su/name-unique-per-tenant :zap-vault/name "Name" :entity.type/zap-vault {})
   (su/multi-ref-field :zap-vault/members "Members" [:entity.type/account] {:authorization    su/access-user-user
                                                                            :editor-type      :editor.type/none
                                                                            :default-field-visibility :in-use
                                                                            :option-filter-fn option-filters/active-users})
   (su/multi-ref-field :zap-vault/teams "Teams" [:entity.type/team] {:authorization su/access-user-user
                                                                     :editor-type   :editor.type/none
                                                                     :default-field-visibility :in-use})

   (su/date-field :zap-vault/archive-date "Automatic archival date" {})
   (su/single-ref-field :zap-vault/configuration "Configuration" [:entity.type/vault-config] {:authorization su/access-system-user})
   (su/text-edn-field :zap-vault/invitees "Invitees" {})
   (su/text-wysiwyg-field :zap-vault/description
                          "Description"
                          {:authorization           su/access-user-user
                           :default-field-visibility :in-use})))
